export default __webpack_public_path__ + "static/media/naoSeiGostariaDeInformacoes.98d661a9.svg";